import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const AlertText = styled.span`
  color: ${theme.color.error};
`;
